var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.totalHits)?_c('span',[_vm._v(" Showing "+_vm._s(_vm.firstHitOnPage)+"-"+_vm._s(_vm.lastHitOnPage)+" of "+_vm._s(_vm.totalHits)+" results")]):_c('span',[_vm._v("0 results")])])}
var staticRenderFns = []

export { render, staticRenderFns }